import axios from "axios";
import { encryptStorage, backendUrl } from "../Configs/Constant";
import { SignInEndpoint } from "../Configs/BackendRoutes";

export const client = async (config: any) => {
    // try {
    //     // config.headers.userName = encryptStorage.getItem('username')
    //      config.headers.authorization = `Bearer ${encryptStorage.getItem('token')}`
        
    //     let response = await axios(config);
    //     console.log(response)
    //     return response.data;

    // }
    // catch (error: any) {

    //     console.log(error.message, "error in client "); 
    //     // window.location.href = '/error'
    // }

    
    try {
        let { url, method, data } = config;
        let Config;
    
        const substrings = [  "sign-in",  "refresh-token",  "login","extract-details"];
        if (!substrings.some(substring => url.includes(substring))) {

          let validateToken = await validateTokenExpiration();
    
          if (validateToken) {
            await getByrefreshTokens();
          }
    
          let getToken = encryptStorage.getItem("token");
    
          Config = {
            headers: {
              "Content-Type": "application/json",
              authorization: `Bearer ${getToken}`,
            },
            data: data,
            url,
            method,
          };
        } else {
          Config = config
        }
    
        const response = await axios(Config);

        return response.data;
      } catch (error: any) {
        console.error(error.message);
        // throw error;
      }
    }



//PS_CF_12,PS_CF_13,PS_CF_14,PS_CF_15,PS_CF_16,PS_CF_17
async function validateTokenExpiration() {
  let getToken = encryptStorage.getItem("token");
  
  const token = getToken ?? "";
  const tokenParts = token.split(".");

  // Get the payload part
  const payload = tokenParts[1];

  const decodedPayload = atob(payload); // Use atob to decode Base64 in the browser
  const parsedPayload = JSON.parse(decodedPayload);

  if (parsedPayload.exp) {
    const currentTimestamp = Math.floor(Date.now() / 1000); // Convert to seconds

    if (parsedPayload.exp < currentTimestamp) {
      return true;
    } else {
      return false;
    }
  }
} 
//PS_CF_18,PS_CF_19,PS_CF_20,PS_CF_21,PS_CF_22,PS_CF_23,PS_CF_24
async function getByrefreshTokens() {
  let getToken = encryptStorage.getItem("refreshToken")

  let bodies: any = {
    refresh_token: getToken,
  };
  let payload = {
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${getToken}`,
    },
    data: bodies,
    url: backendUrl + SignInEndpoint.RefreshToken, // Add the url property
    method: "post", // Add the method property
  };
  
  let response = await axios(payload);
  
  encryptStorage.setItem(
    "token",response?.data?.data?.jwt);
  encryptStorage.setItem(
    "refreshToken",response?.data?.data?.refreshToken);
}